import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetCustomerGroupReport = () => {
  const Api = useApi()
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const initialFilters = {
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today
    sort_by: 'total_shipping/-1',
    customer_group_id: '',
  }

  const {filters, onDateChange, onSortingChange, setMultipleFilters} = useFilters(initialFilters, {
    sortType: 'number',
  })

  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/shipping-report/customer-groups',
    {
      queryId: 'shipping-customer-group-report',
      filters,
      isToast: false,
      isErrorPageRedirection: false,
    }
  )

  const onChangeCustomerGroupFilter = (values: any[]) => {
    setMultipleFilters({
      customer_group_id: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
  }

  return {
    reportData: response?.data || [],
    isLoading: isFetching,
    filters,
    onSortingChange,
    handleCustomerGroupReportDateChange: onDateChange,
    pagination: response?.meta?.pagination || {},
    onChangeCustomerGroupFilter,
  }
}

export default useGetCustomerGroupReport
